import React from 'react';
import PropTypes from 'prop-types';
import useApi from '../hooks/useApi';
import { Star, StarBorderOutlined } from '@mui/icons-material';

const FavoriteButton = ({ dashboardId, isFavorite, onToggle }) => {
    const { callApi, loading } = useApi(
        `https://vision.alfama.com/api/update/dashboards/favorito/${dashboardId}`,
        {
            method: 'GET',
            includeToken: true,
            successMessage: 'Favorito atualizado!',
            errorMessage: 'Erro ao atualizar favorito',
        }
    );

    const handleFavoriteClick = async (e) => {
        e.stopPropagation();
        if (loading) return;

        // Chama onToggle ANTES para garantir feedback imediato
        const novoEstado = !isFavorite;
        onToggle(dashboardId, novoEstado);

        try {
            await callApi();
        } catch (error) {
            console.error('Erro no handleFavoriteClick:', error);
            // Reverte em caso de erro
            onToggle(dashboardId, isFavorite);
        }
    };

    return (
        <button
            onClick={handleFavoriteClick}
            disabled={loading}
            className="p-1 text-gray-400 hover:text-yellow-500 transition-colors disabled:opacity-50 z-20"
            aria-label={isFavorite ? 'Remover dos favoritos' : 'Adicionar aos favoritos'}
        >
            {isFavorite ? <Star className="text-yellow-500" /> : <StarBorderOutlined />}
        </button>
    );
};

FavoriteButton.propTypes = {
    dashboardId: PropTypes.number.isRequired,
    isFavorite: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
};

export default React.memo(FavoriteButton);
